import PropTypes from 'prop-types';
import ImageProp from '../../../commonComponents/propTypes/imageProp';
import ModuleProp from './moduleProp';
import CourseRewardsProp from './courseRewardsProp';
import { COURSE_STATUSES, COURSE_PROVIDERS } from '../../../services/utilityFunctions';

const propType = {
  _id: PropTypes.string,
  slug: PropTypes.string,
  name: PropTypes.string,
  summary: PropTypes.string,
  description: PropTypes.string,
  motivation: PropTypes.string,
  requirements: PropTypes.string,
  image: PropTypes.oneOfType([
    PropTypes.shape(ImageProp.propType),
    PropTypes.string,
  ]),
  imageSquare: PropTypes.shape(ImageProp.propType),
  duration: PropTypes.number,
  status: PropTypes.oneOf(COURSE_STATUSES).string,
  modules: PropTypes.number,
  modulesList: PropTypes.arrayOf(PropTypes.shape(ModuleProp.propType)),
  certificate: PropTypes.shape({
    isActive: PropTypes.bool.isRequired,
    color: PropTypes.string,
    link: PropTypes.string,
    logo: PropTypes.shape(ImageProp.propType),
    signature: PropTypes.shape(ImageProp.propType),
  }),
  skillLevel: PropTypes.shape({
    icon: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  rewards: PropTypes.shape(CourseRewardsProp.propType),
  inAppProduct: PropTypes.shape({ price: PropTypes.number.isRequired }),
  inAppPromotion: PropTypes.shape({ price: PropTypes.number.isRequired }),
  isFromExternalProvider: PropTypes.bool,
  provider: PropTypes.shape({
    service: PropTypes.oneOf(COURSE_PROVIDERS).string,
    config: PropTypes.shape({
      scorm: PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        learningStandard: PropTypes.string,
        url: PropTypes.string,
        urlUser: PropTypes.string,
      }),
    }),
  }),
  contentAvailableBeforePayment: PropTypes.bool,
  isManualComplete: PropTypes.bool,
};

const defaultProp = {
  _id: '',
  slug: '',
  name: '',
  summary: '',
  description: '',
  motivation: '',
  requirements: '',
  image: {},
  imageSquare: {},
  duration: 0,
  status: '',
  modules: 0,
  modulesList: [],
  skillLevel: {},
  rewards: {},
  isFromExternalProvider: false,
  contentAvailableBeforePayment: false,
  provider: {},
  isManualComplete: false,
};

export default { propType, defaultProp };
